module.exports = __webpack_public_path__ + "img/9.30f79dda.webp";